import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../shared/service/axios";
import { DashboardResponse } from "./Common.constants";

export const useDashboardMutation = (): UseMutationResult<
  DashboardResponse,
  AxiosError,
  any
> =>
  useMutation<DashboardResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("general/home");

    return data;
  });
